/**
 * Browsers and Node store a setTimeout/setInterval delay in a 32-bit signed
 * int; a delay above this overflows and gets silently truncated to 1ms, so
 * the callback fires almost immediately instead of respecting the intended
 * (much longer) delay. A delay derived from `<server timestamp> - Date.now()`
 * can exceed this whenever the local clock is far behind the server's, or a
 * test pins the clock (#17351).
 */
export const MAX_TIMER_DELAY_MS = 2_147_483_647;

/** Clamps a delay computed from a server timestamp to a safe setTimeout/setInterval range. */
export function clampTimerDelay(delayMs: number): number {
  return Math.min(Math.max(delayMs, 0), MAX_TIMER_DELAY_MS);
}
